import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const HrSystemInfoAlert = ({
  openHrSystemInfo,
  setOpenHrSystemInfo,
  handleHeSystemConnect,
  colors,
}) => {
  return (
    <Collapse sx={{ width: "100%" }} in={openHrSystemInfo}>
      <Alert
        severity="info"
        icon={
          <ErrorRoundedIcon sx={{ width: "20px", color: colors.info_dark }} />
        }
        sx={{
          backgroundColor: colors.info_8percent,
          border: "1px solid " + colors.info_16percent,
          borderRadius: "8px",

          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            sx={{}}
            onClick={() => {
              setOpenHrSystemInfo(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle
          sx={{
            margin: 0,
          }}
        >
          <Typography variant="subtitle1" sx={{ color: colors.info_dark }}>
            Connect your HR System
          </Typography>
        </AlertTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.text_primary,
            }}
          >
            To unlock detailed info and streamline permissions management,
            connect your HR system to Breeze.
          </Typography>

          <PrimaryButton
            onClick={handleHeSystemConnect}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              padding: 1,
              height: "30px",
              backgroundColor: colors.info_dark,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography variant="overline">Go To Integrations</Typography>
              <ArrowForwardIcon sx={{ width: "12px" }} />
            </Box>
          </PrimaryButton>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default HrSystemInfoAlert;
